/*=========================================================================================
  File Name: moduleActivityActions.js
  Description: Activity Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Felix Masa
==========================================================================================*/

import Api from "@/helpers/api.js";
import Activity from "@/models/Activity.js";

export default {
	addActivityItem({commit, dispatch}, activity) {
		return new Promise((resolve, reject) => {
			Api.post("/activity", activity)
				.then((response) => {
					const newActivity = new Activity(activity);
					commit("ADD_ACTIVITY_ITEM", Object.assign(newActivity, {id: response.data.id}));
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchActivityListItems({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/activity")
				.then((response) => {
					commit("SET_ACTIVITIES", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchActivityById({commit}, itemId) {
		return new Promise((resolve, reject) => {
			Api.get(`/activity/${itemId}`)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	updateActivityItem({commit}, activity) {
		return new Promise((resolve, reject) => {
			Api.put(`/activity/${activity.id}`, activity)
				.then((response) => {
					const upActivity = new Activity(activity);
					commit("UPDATE_ACTIVITY", upActivity);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeActivityItem({commit}, itemId) {
		return new Promise((resolve, reject) => {
			Api.delete(`/activity/${itemId}`)
				.then((response) => {
					commit("REMOVE_ACTIVITY_ITEM", itemId);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchFormsActivityList({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/forms/list")
				.then((response) => {
					commit("SET_FORMS_ACTIVITIES", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchActivityPaginated({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = {
				page: data.page || null,
				quantity: data.quantity || null,
				id: data.id || [],
				name: data.name || "",
				order_by: data.order_by || "name",
				sort: data.sort || "ASC",
				fields: data.fields || null,
				on_demand: data.on_demand || null,
			};
			Api.post("/activity/filter", payload)
				.then((res) => {
					commit("SET_ASSIGNED_ACTIVITIES", res.data.records);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
